export const MINIMUM_COVERAGES_AMOUNT = 2;
export const MINIMUM_COVERAGES_AMOUNT_MESSAGE = `São necessárias pelo menos ${MINIMUM_COVERAGES_AMOUNT} coberturas selecionadas!`;
